import React from "react"

// Material Core
import {makeStyles} from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Breadcrumbs from "@material-ui/core/Breadcrumbs"

// Material Icon
import NavigateNextIcon from "@material-ui/icons/NavigateNext"

// Custom Style
import styles from "../../styles/jss/components/fileManager/fileManagerNavStyle"


const useStyles = makeStyles(styles)

const FileManagerNav = props => {
	const classes = useStyles()
	const {folderPath} = props

	return (
		<Box className={classes.root}>
			<Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" >
				{
					folderPath !== null ?
						folderPath.map((res, key) => {
							return <div color="inherit" href="/" key={key} className={classes.font}>{res}</div>
						})
					: ""
				}
			</Breadcrumbs>
		</Box>
	)
}


export default FileManagerNav